import * as log from 'loglevel';
import Api from './Api';

class Podcast extends Api {
  loadHomeCategories() {
    const getHomeBucket = new Promise((resolve, reject) => {
      super.getList('/v1/home').then((buckets) => {
        resolve(buckets);
      }).catch((error) => {
        reject(error);
      });
    });

    return getHomeBucket;
  }

  loadContinueListeningBucket() {
    return new Promise((resolve, reject) => {
      this.fetchContinueListening().then((bucket) => {
        resolve(bucket);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  loadRecommendedPodcastsBucket() {
    return new Promise((resolve, reject) => {
      super.getList('/v1/home/recommended-podcasts').then((bucket) => {
        resolve(bucket);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  loadByBundleId(id) {
    return new Promise((resolve, reject) => {
      super.getList('/v1/home/{bundle_uuid}', { bundle_uuid: id })
        .then((buckets) => {
          resolve(buckets);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  loadOnboardingTopics() {
    return new Promise((resolve, reject) => {
      super.getList('/v1/onboarding_topics').then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  loadCategories() {
    return new Promise((resolve, reject) => {
      super.getList('/v1/categories').then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  loadCategoryPodcasts(categories) {
    return new Promise((resolve, reject) => {
      super.getList('/v1/categories-uuids', { uuids: categories }).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getPodcastsById(ids) {
    return new Promise((resolve, reject) => {
      super.getList('/v1/podcasts-uuids', { uuids: ids }).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getPodcastById(id) {
    return new Promise((resolve, reject) => {
      super.get('/v1.1/podcasts/{podcast_uuid}', { podcast_uuid: id }).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getPodcastBySlug(slug) {
    return new Promise((resolve, reject) => {
      super.get('/v1/podcasts/slug/{podcast_slug}', { podcast_slug: slug }).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getPodcastByCategoryId(categoryId, limit, page) {
    return new Promise((resolve, reject) => {
      const params = {
        category_uuid: categoryId,
        p: page,
        limit,
      };
      super.get('/v1/categories/{category_uuid}', params).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getPlaylistData(params) {
    return new Promise((resolve, reject) => {
      super.getList('/v1/playlist', params).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  sortList(podcasts) {
    podcasts.sort((item1, item2) => {
      if (item1.position < item2.position) {
        return -1;
      } if (item1.position > item2.position) {
        return 1;
      }
      return 0;
    });
    return podcasts;
  }

  async getPodcastsFromLibrary(_limit, _page) {
    return new Promise((resolve, reject) => {
      super.getList('/v1.1/user/podcast', { limit: _limit, p: _page })
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async addPodcastsToLibrary(id) {
    return new Promise((resolve, reject) => {
      const formData = {
        podcast_uuid: id,
      };
      super.post('/v1/user/podcast', formData)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async deletePodcastFromLibrary(id) {
    return new Promise((resolve, reject) => {
      const params = {
        user_podcast_uuid: id,
      };
      super.delete('/v1/user/podcast/{user_podcast_uuid}', params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  updatePodcastViewDate(id) {
    return new Promise((resolve, reject) => {
      const params = {
        user_podcast_uuid: id,
        position: null,
        last_viewed_at: 'now',
      };
      super.put('/v1/user/podcast/{user_podcast_uuid}', params)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async updatePodcastPosition(id, pos) {
    return new Promise((resolve, reject) => {
      const params = {
        user_podcast_uuid: id,
        position: pos,
        lastViewedAt: null,
      };
      super.put('/v1/user/podcast/{user_podcast_uuid}', params)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPodcastTrailers(id) {
    return new Promise((resolve, reject) => {
      super.get('/v1/podcasts/{podcast_uuid}/trailers', { podcast_uuid: id })
        .then(resp => resolve(resp))
        .catch(error => reject(error.message));
    });
  }

  getPodcastRatings(id) {
    return new Promise((resolve, reject) => {
      super.put('/v1/user/ratings/{podcast_uuid}', { podcast_uuid: id })
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  savePodcastRating(id, data) {
    return new Promise((resolve, reject) => {
      const params = data;
      params.podcast_uuid = id;

      super.put('/v1/user/ratings/{podcast_uuid}', params)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  savePodcastFeedback(id, comments) {
    return new Promise((resolve, reject) => {
      const params = {
        podcast_uuid: id,
        content: comments,
      };
      super.post('/v1/user/podcast_feedback/{podcast_uuid}', params)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPodcastFeedback(id) {
    return new Promise((resolve, reject) => {
      const params = {
        podcast_uuid: id,
      };
      super.get('/v1/user/podcast_feedback/{podcast_uuid}', params)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPodcastRating(id) {
    return new Promise((resolve, reject) => {
      super.get('/v1/user/ratings/{podcast_uuid}', { podcast_uuid: id })
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getRatings() {
    return new Promise((resolve, reject) => {
      super.getList('/v1/ratings')
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  deleteRating(id) {
    return new Promise((resolve, reject) => {
      super.delete('/v1/user/ratings/{podcast_uuid}', { podcast_uuid: id })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getTags() {
    return new Promise((resolve, reject) => {
      super.getList('/v1/tags')
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPodcastTags(id) {
    return new Promise((resolve, reject) => {
      super.get('/v1/podcast/tags/{podcast_uuid}', { podcast_uuid: id })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPodcastEpisodesByPodcastId(podcastId) {
    return new Promise((resolve) => {
      this.getPodcastById(podcastId).then((resp) => {
        if (resp && resp.seasons && resp.seasons.length) {
          let podcastEpisodes = [];
          resp.seasons.forEach((season) => {
            if (season.episodes && season.episodes.length) {
              podcastEpisodes = podcastEpisodes.concat(season.episodes);
            }
          });
          podcastEpisodes.sort((a, b) => new Date(a.released_at) - new Date(b.released_at)); // ascending order episodes
          podcastEpisodes = podcastEpisodes.map((episode) => {
            const tempEpisode = episode;
            tempEpisode.season = { podcast: { uuid: resp.uuid, image_url: resp.image_url, display_image_url: resp.display_image_url } };
            return tempEpisode;
          });
          resolve(podcastEpisodes);
        }
      }).catch((error) => {
        log.error(error);
      });
    });
  }

  fetchContinueListening() {
    return super.getList('/v1/home/continuelistening');
  }

  // loadContinueListeningBucket() {
  //   return new Promise((resolve, reject) => {
  //     const { user, token } = window.$store.getters;
  //     if (!user || !token) {
  //       resolve(null);
  //     }
  //     this.fetchContinueListening().then((continueListeningBucket) => {
  //       resolve(continueListeningBucket);
  //     }).catch((error) => {
  //       reject(error);
  //     });
  //   });
  // }

  getUserLibraryPodcastIds() {
    return new Promise((resolve, reject) => {
      super.get('/v1/user/library/podcastids')
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPodcastEpisodesByPodcastUuid(params) {
    return new Promise((resolve, reject) => {
      super.getList('/v1.1/podcasts/{podcast_uuid}/episodes', params).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getExclusivePodcasts(p = 1, limit = 50) {
    const params = {
      p,
      limit,
    };

    return new Promise((resolve, reject) => {
      super.getList('/v1/podcasts/exclusive', params).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }
}

export default Podcast;



// WEBPACK FOOTER //
// ./app/src/services/Podcast.js